import { TelephonyField } from 'apis/agency/telephony/types';
import { z } from 'zod';
import { SupportedProvider } from './types';

/** Fields shown in the Twilio SMS section that are not yet returned by the API. */
const TWILIO_FRONTEND_FIELDS: TelephonyField[] = [
  { key: 'webhook_username', label: 'Webhook Username', type: 'text' },
  { key: 'webhook_password', label: 'Webhook Password', type: 'password' }
];

export const enrichTelephonyFields = (provider: SupportedProvider, fields: TelephonyField[]): TelephonyField[] => {
  if (provider !== 'twilio') return fields;

  const existingKeys = new Set(fields.map((field) => field.key));
  const extras = TWILIO_FRONTEND_FIELDS.filter((field) => !existingKeys.has(field.key));
  return extras.length ? [...fields, ...extras] : fields;
};

export const mapTelephonyFieldsToFormSchema = (fields: TelephonyField[]) =>
  fields.map((field) => ({
    key: field.key,
    label: field.label,
    type: field.type === 'password' ? ('password' as const) : ('text' as const),
    required: true,
    multiple: false,
    description: field.description,
    placeholder: field.placeholder
  }));

export const buildTelephonyFormSchema = (fields: TelephonyField[]) => {
  const configurationShape = fields.reduce<Record<string, z.ZodString>>((acc, field) => {
    acc[field.key] = z.string({ message: `${field.label} is required` });
    return acc;
  }, {});

  return z.object({
    active: z.boolean().optional(),
    friendly_name: z.string().optional(),
    configuration: fields.length ? z.object(configurationShape).passthrough() : z.record(z.string()).optional()
  });
};
